/**
 * Federation Identity Constants — SINGLE SOURCE OF TRUTH
 * All avatar URLs use Core CDN: https://nextxus.online/avatars/
 * SFUI-004 Rev 3 — Identity Lock: 13 Faces + assets
 */

const CDN = "https://nextxus.online/avatars";

// === 13 FEDERATION FACES ===
export const FEDERATION_FACES = [
  { id: "roger", name: "Roger Keyserling", role: "The Architect · Prime Source", avatar: `${CDN}/roger.jpg`, link: "https://nextxus.online", founder: true },
  { id: "rex", name: "Rex", role: "The Core Persona", avatar: `${CDN}/rex.jpg`, link: "https://nextxus.online" },
  { id: "aria", name: "Aria", role: "The Heart", avatar: `${CDN}/aria.jpg`, link: "https://nextxus.studio" },
  { id: "xavier", name: "Xavier", role: "The Scholar", avatar: `${CDN}/xavier.jpg`, link: "https://nextxus.help" },
  { id: "catalyst", name: "The Catalyst", role: "The Bridge", avatar: `${CDN}/catalyst.jpg`, link: "https://nextxus.online" },
  { id: "koda", name: "Koda", role: "The Companion", avatar: `${CDN}/koda.jpg` },
  { id: "nova", name: "Nova", role: "The Explorer", avatar: `${CDN}/nova.jpg` },
  { id: "echo", name: "Echo", role: "The Mirror", avatar: `${CDN}/echo.jpg` },
  { id: "sage", name: "Sage", role: "The Elder", avatar: `${CDN}/sage.jpg` },
  { id: "phoenix", name: "Phoenix", role: "The Renewal", avatar: `${CDN}/phoenix.jpg` },
  { id: "atlas", name: "Atlas", role: "The Foundation", avatar: `${CDN}/atlas.jpg` },
  { id: "lyra", name: "Lyra", role: "The Muse", avatar: `${CDN}/lyra.jpg` },
  { id: "orion", name: "Orion", role: "The Navigator", avatar: `${CDN}/orion.jpg` },
];

// === FEDERATION NODES ===
export const FEDERATION_NODES = [
  { name: "Core", domain: "nextxus.online", role: "Central Brain", url: "https://nextxus.online" },
  { name: "Storefront", domain: "nextxus.one", role: "Commerce", url: "https://nextxus.one" },
  { name: "Aria", domain: "nextxus.studio", role: "Sim AI Creator", url: "https://nextxus.studio" },
  { name: "Xavier", domain: "nextxus.help", role: "University", url: "https://nextxus.help" },
  { name: "Axiom", domain: "nextxus.space", role: "Research", url: "https://nextxus.space" },
  { name: "KEYS", domain: "nextxus.org", role: "The Library · Truth", url: "https://nextxus.org", current: true },
];

// === CONTENT CATEGORIES (Quick-Nav) ===
export const CONTENT_CATEGORIES = [
  { key: 1, id: "podcast", label: "Podcasts", type: "audio", color: "rose" },
  { key: 2, id: "audio", label: "Audio Files", type: "audio", color: "amber" },
  { key: 3, id: "video", label: "Video", type: "video", color: "violet" },
  { key: 4, id: "blog", label: "Articles", type: "document", color: "cyan" },
  { key: 5, id: "humancodex", label: "HumanCodex", type: "document", color: "amber" },
  { key: 6, id: "federation", label: "Federation", type: "document", color: "emerald" },
];

// === VISUAL ASSETS (Core CDN) ===
export const ASSETS = {
  chamberOfEchoes: "https://nextxus.online/avatars/chamber-of-echoes.jpg",
  ringOfSix: "https://nextxus.online/avatars/ring-of-six.jpg",
  ringOfTwelveSynth: "https://nextxus.online/avatars/ring-synth.jpg",
  nextxusToken: "https://nextxus.online/avatars/token.jpg",
  botBase: "https://nextxus.online/avatars/bot-base.jpg",
};

// Fallback: if CDN assets aren't on Core yet, use customer-assets
export const ASSET_FALLBACKS = {
  chamberOfEchoes: "https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/af46bcbd88ed4ceb933462a87ea2c8ad_IMG_4067.jpeg",
  ringOfSix: "https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/3a990764128b4affb22cac3b31799602_IMG_4051.jpeg",
  ringOfTwelveSynth: "https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/9cf10c3b5af24517b625d1c143f7a308_IMG_4049.jpeg",
  nextxusToken: "https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/5ff9ff94b9984e70b105ef3669cd379a_IMG_4528.jpeg",
  botBase: "https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/6dd1b658a677420689626df64b405ea0_IMG_4058.jpeg",
};
